var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    clipPath: "url(#clip0_109_430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 8.18344C12.1899 8.18344 8.68344 11.6899 8.68344 16C8.68344 20.3101 12.1899 23.8166 16.5 23.8166C20.8101 23.8166 24.3166 20.3101 24.3166 16C24.3166 11.6899 20.8101 8.18344 16.5 8.18344ZM15.3977 19.6448L12.3754 16.6224L13.7012 15.2966L15.3978 16.9932L19.3728 13.0182L20.6986 14.344L15.3977 19.6448Z",
    fill: "#F8C200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.5 18.5875V13.4125L29.3039 12.4842C29.0116 11.4201 28.5872 10.3989 28.0374 9.43669L29.6432 6.51594L25.984 2.85669L23.0633 4.46263C22.1011 3.91281 21.08 3.4885 20.0158 3.19606L19.0874 0H13.9125L12.9841 3.19606C11.9199 3.48844 10.8988 3.91281 9.93656 4.46263L7.01587 2.85669L3.35663 6.51594L4.9625 9.43669C4.41269 10.3989 3.98831 11.4201 3.69594 12.4842L0.5 13.4125V18.5875L3.69606 19.5158C3.98844 20.5799 4.41281 21.6011 4.96263 22.5633L3.35675 25.4841L7.016 29.1433L9.93669 27.5374C10.8989 28.0872 11.92 28.5115 12.9843 28.8039L13.9126 32H19.0875L20.0159 28.8039C21.0801 28.5116 22.1012 28.0872 23.0634 27.5374L25.9841 29.1433L29.6434 25.4841L28.0375 22.5633C28.5873 21.6011 29.0117 20.5799 29.3041 19.5158L32.5 18.5875ZM16.5 25.6916C11.1561 25.6916 6.80844 21.3439 6.80844 16C6.80844 10.6561 11.1561 6.30844 16.5 6.30844C21.8439 6.30844 26.1916 10.6561 26.1916 16C26.1916 21.3439 21.8439 25.6916 16.5 25.6916Z",
    fill: "#F8C200"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.e8de0cfa7ce4f32f15e204990e3a2312.svg";
export { ForwardRef as ReactComponent };